import type { CalendarDesign } from "#internal"

import { PictureCover } from "../PictureCover"
import { Nelson } from "./Nelson"

/** Belwe, a square desk calendar: the year big at the foot of its picture; a month as Nelson's. */
export const Belwe: CalendarDesign = { ...Nelson, cover: PictureCover({ at: 0.05, size: 0.2 }) }
